import { createFileRoute, notFound } from '@tanstack/react-router';
import { SingleWorkflowView } from '~/components/ui/workflow/SingleWorkflowView';
import { canAccess } from '~/utils/rbac';

export const Route = createFileRoute('/_authLayout/workflows/$workflowId')({
  beforeLoad: async () => {
    if (!canAccess('workflow')) {
      throw notFound();
    }
  },
  component: WorkflowDetailPage,
});

function WorkflowDetailPage() {
  const { workflowId } = Route.useParams();
  return <SingleWorkflowView workflowId={workflowId} />;
}
